// TODO das sollte nach inter-theme-web
// TODO auf benötigte schriftarten reduzieren (wenn möglich...)
import 'typeface-barlow/index.css';
import 'typeface-barlow-semi-condensed/index.css';

